<template>
    <v-toolbar 
        flat
        dense
    >
        <v-btn
            id="refresh"
            depressed            
            :class="timerEnabled ? 'run' : 'pause'"            
            @click="refreshTicketTab()"
        >
            <v-icon>
                mdi-refresh
            </v-icon>                      
            {{ countDown ? formatedCountdown :'Update' }}            
        </v-btn>
        <v-btn
            v-if="!timerEnabled"           
            depressed
            small
            fab
            icon
        >
            <v-icon
               
                @click="play"
            >
                play_arrow
            </v-icon>
        </v-btn>
        <v-btn 
            v-if="timerEnabled && countDown"                      
            depressed            
            small
            fab
            icon
        >
            <v-icon
                
                @click="pause"
            >
                mdi-pause
            </v-icon>
        </v-btn>
    </v-toolbar>
</template>
<script>
import * as moment from 'moment';
import 'moment-duration-format';
export default {
    props: {
        refreshMinutes: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            timerEnabled: true,
            // convert minutes to seconds
            timerCount: this.refreshMinutes * 60,
            countDown: true
        };
    },
    computed: {
        formatedCountdown() {
            return moment.duration(this.timerCount, 'seconds').format('mm:ss',{
                trim: false
            });
        }
    },
    watch: {
        timerEnabled(value) {
            if (value) {                
                setTimeout(() => {
                    this.timerCount--;
                }, 1000);
            }
        },
        timerCount: {
            handler(value) {
                this.countDown = this.refreshMinutes * 60 > 0 ? true : false;
                if (value > 0 && this.timerEnabled && this.countDown) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                }
                if (value === 0 && this.countDown) {
                    this.refreshTicketTab();
                    clearTimeout(this.timerCount);
                    this.setTimerCount();
                }
                // if(!this.countDown && this.timerEnabled){
                //     setTimeout(() => {
                //         this.timerCount++;
                //     }, 1000);
                // }
            },
            immediate: true // This ensures the watcher is triggered upon creation
        }
    },
    methods: {
        play() {
            this.timerEnabled = true; 
        },
        pause() {
            this.timerEnabled = false;
        },
        setTimerCount() {
            this.timerCount = this.refreshMinutes;           
        },
        refreshTicketTab(){
            this.timerEnabled = true;
            clearTimeout(this.timerCount);
            this.setTimerCount();
            this.$emit('refreshTicketTab');         
        }
    }
};
</script>
<style>
.run{
     /* background-color: 'rgba(73, 200, 79, .1) !important' */
    background-color: rgba(73, 200, 79,.2) !important;
    border: 1px solid rgba(73, 200, 79, .5) !important;
    margin-left: 10px;
    margin-right: 10px;
  
}
.pause {    
    background-color: rgba(240, 240, 79,.2) !important;
    border: 1px solid rgba(240, 240, 79, .5) !important;
    margin-left: 10px;
    margin-right: 10px;
       
}
</style>